import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/lottery/goods/list'
    return request.post(url,data)
}

export function all() {
    let url = '/lottery/goods/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/lottery/goods/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/lottery/goods/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/lottery/goods/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/lottery/goods/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/lottery/goods/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/lottery/goods/dmz/options'
    return request.get(url)
}
